import React from 'react';
import { formatNumber } from '../../../common/lib/formatNumber';
import type { BoatAd } from '../../../types';

type BoatSummaryProps = {
    ad: BoatAd;
    className?: string;
};

export function BoatSummary(props: BoatSummaryProps) {
    const { ad, className = '' } = props;

    const getLengthText = (length: number) => `${formatNumber(length)} fot`;
    const getPriceText = (amount: number) =>
        `${formatNumber(amount)} ${ad.price.price_unit}`;

    return (
        <div className={`${className} space-x-12 font-bold whitespace-nowrap`}>
            {ad.year > 0 && <span>{ad.year}</span>}
            {ad.length && ad.length > 0 && (
                <span>{getLengthText(ad.length)}</span>
            )}
            {ad.price.amount > 0 && (
                <span>{getPriceText(ad.price.amount)}</span>
            )}
        </div>
    );
}
